import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {IUser} from "../models/subscription.model";
import {SettingsService} from "./settings.service";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  private _currentUser = new BehaviorSubject<IUser>(null);

  constructor(
    private settingsService: SettingsService
  ) {
    this.settingsService._settings.subscribe(settings => {
      this.user = {
        ...this.user,
        ...settings
      };
    })
  }

  set user(newUser: IUser) {
    if(!newUser.id) newUser.id = (newUser as unknown as {userId: string}).userId
    this._currentUser.next(newUser);
  }

  get userObservable(): Observable<IUser> {
    return this._currentUser.asObservable();
  }

  get user(): IUser {
    return this._currentUser.value;
  }


}
